(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('KnowledgeBaseSettingsController', knowledgeBaseSettingsController);

  knowledgeBaseSettingsController.$inject = ['CompanyService', 'NotificationService', '$rootScope', 'LangService'];

  function knowledgeBaseSettingsController (CompanyService, NotificationService, $rootScope, LangService) {
    var vmKnowledgeBaseCtrl = this;

    vmKnowledgeBaseCtrl.labels = '';

    LangService
      .getPageLabels({ 'page': 'menu.config.knowledgebase' })
      .$promise
      .then(function (data) {
        vmKnowledgeBaseCtrl.labels = data.lang;
      });

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmKnowledgeBaseCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

    vmKnowledgeBaseCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmKnowledgeBaseCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.updateConfigSuccessfull);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.updateConfigError);
        });
    }
  }
})();
